import { gql } from "@apollo/client";

export const GET_PLANES_SEARCH = gql`
query GET_PLANES_SEARCH(
    $filter: PlanCuidadoSearchFilterInput! 
) {
    planesSearch(filter: $filter)
    {
        success,
        error,
        valorEsperado {          
            idPlanCuidado,
            codigoSap,
            nombre,
            tipoModulo,
            cotizado,
            descripcionComplejidad,
            complejidadTipoModulo
        }
    }
}`;

export const adaptPlan = (plan) => {
  return {
    id: plan?.idPlanCuidado,
    codigoSap: plan?.codigoSap,
    programa: plan?.tipoModulo,
    nombre: plan?.nombre,
    complejidad: plan?.descripcionComplejidad,
    complejidadModulo: plan?.complejidadTipoModulo,
    cotizado: plan?.cotizado ? 'SI' : 'NO'
  };
};

export const adaptPlanesArray = (
planes) =>
{
  return structuredClone(planes)?.
  map((plan) => adaptPlan(plan));
};